<template>
  <!-- banner div  -->
  <div class="fou-dashboard-top-part--bannerDiv">
    <span v-if="hasFoundryProfilePermission" class="fou-dashboard-top-part--bannerDiv__tooltip" data-qa-id="edit-display-info-icon-banner" @click="brandYourProfile" >
      <span class="info-icon">
        <MdIconEdit icontitle="disabled" rotate="down" size="sm" color="blue-duck--500" />
      </span>
    </span>
    <span class="fou-dashboard-top-part--bannerDiv__imageBackground" :style="{ backgroundImage: bannerURL ? `url(${bannerURL})` : `url(${defaultBannerUrl})` }" />
  </div>
  <!-- logo div  -->
  <div class="fou-dashboard-top-part--logoDiv">
    <span v-if="hasFoundryProfilePermission" class="fou-dashboard-top-part--logoDiv__tooltip" data-qa-id="edit-display-info-icon-logo" @click="brandYourProfile">
      <span class="info-icon">
        <MdIconEdit icontitle="disabled" rotate="down" size="sm" color="blue-duck--500" />
      </span>
    </span>
    <span v-if="logoURL" class="fou-dashboard-top-part--logoDiv__imageBackground" :style="{ backgroundImage: `url(${logoURL})` }" />
    <span v-else class="currentFoundryInitial">
      {{ foundryNameInitials }}
    </span>
  </div>
</template>
<script src="./script.js"></script>
<style lang="scss" src="./stylesheet/index.scss" />